import { pdf } from "@react-pdf/renderer";
import type { SolicitacaoPagamentoDto } from "@/services/solicitacaoPagamento";
import { PaymentRequestPdfDocument } from "./PaymentRequestPdfDocument";
import { buildPaymentRequestPdfModel } from "./paymentRequestPdfModel";

async function renderPdfBlob(item: SolicitacaoPagamentoDto, geradoPor: string): Promise<{
  blob: Blob;
  filenameBase: string;
}> {
  const model = buildPaymentRequestPdfModel(item, geradoPor);
  const blob = await pdf(<PaymentRequestPdfDocument data={model} />).toBlob();
  return { blob, filenameBase: model.filenameBase };
}

function openPdfBlob(blob: Blob): Window | null {
  const url = URL.createObjectURL(blob);
  return window.open(url, "_blank");
}

function downloadPdfBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename.endsWith(".pdf") ? filename : `${filename}.pdf`;
  anchor.click();
  URL.revokeObjectURL(url);
}

export async function generatePaymentRequestPdf(
  item: SolicitacaoPagamentoDto,
  geradoPor: string,
): Promise<void> {
  const { blob, filenameBase } = await renderPdfBlob(item, geradoPor);
  openPdfBlob(blob);
  downloadPdfBlob(blob, filenameBase);
}

export async function printPaymentRequestPdf(
  item: SolicitacaoPagamentoDto,
  geradoPor: string,
): Promise<void> {
  const { blob } = await renderPdfBlob(item, geradoPor);
  const url = URL.createObjectURL(blob);
  const win = window.open(url, "_blank");
  if (!win) {
    URL.revokeObjectURL(url);
    throw new Error("Não foi possível abrir a janela de impressão. Verifique o bloqueador de pop-ups.");
  }
  const triggerPrint = () => {
    try {
      win.focus();
      win.print();
    } catch {
      /* impressão depende do visualizador PDF do navegador */
    }
  };
  win.addEventListener("load", triggerPrint);
  window.setTimeout(triggerPrint, 800);
}
